export default __webpack_public_path__ + "static/media/P940MANB12.8336bbd0.pdf";